export default {
	addCity: 'Dodaj miasto',
	city: 'Miasto',
	country: 'Kraj',
	countryRequired: 'Kraj wymagany',
	options: 'Opcje',
	edit: 'Edytuj',
	editingCity: 'Edytuj miasto',
	areYouSureYouWantToDeleteCity: 'Czy na pewno chcesz usunąć miasto z systemu?',
	cityCenterCoordinates: 'Współrzędne centrum miasta',
	latitude: 'Szerokość geograficzna',
	longitude: 'Długość geograficzna'
};
